import { TabNavItem } from './types';

const i18nPathPrefix = 'navService.items';

const navMenus = [{
  navId: 'dashboard',
  icon: 'dashboard',
  textI18nPath: `${i18nPathPrefix}.dashboard`,
  route: '/m/feature/unified-insights',
}, {
  navId: 'reports',
  icon: 'management-reporting',
  textI18nPath: `${i18nPathPrefix}.reports`,
  route: '/m/feature/unified-reports',
}];

export const tabNavItems: TabNavItem[] = [
  {
    navId: 'unifiedInsights',
    color: '#fda348',
    icon: 'dashboard',
    textI18nPath: `${i18nPathPrefix}.unifiedInsights`,
    navTree: {
      navId: '__root',
      textI18nPath: 'rootNode',
      children: navMenus,
    },
  },
];
